import { render, staticRenderFns } from "./FabricAdjustment.vue?vue&type=template&id=44005762&"
import script from "./FabricAdjustment.vue?vue&type=script&lang=js&"
export * from "./FabricAdjustment.vue?vue&type=script&lang=js&"
import style0 from "./FabricAdjustment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports